export const pricingLevelSecretKeyCookieName = "pricingLevelSecretKey";
